import React, { useEffect } from 'react';

import { StyleSheet, css } from 'aphrodite';
import { Checkbox, Chip, createMuiTheme, createStyles, FormControlLabel, makeStyles, MuiThemeProvider, Radio, Slider, TextField, Tooltip } from '@material-ui/core';
import { Helper } from '../common/helpers/Helper';
// import { styles } from 'material-ui-pickers/wrappers/InlineWrapper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, TimePicker } from 'material-ui-pickers'
import { DatePicker } from 'material-ui-pickers'
// import { DateTimePicker } from 'material-ui-pickers'
import moment from 'moment-timezone'
import MomentUtils from '@date-io/moment'
import { AppConfig } from '../AppConfig';

export function Label(props) {
  return (
    <div className={css(Styles.labelContainer)}>
      <p className={css(Styles.label)}>{props.label}</p>
      {props.item && props.item.helpText &&
        <Tooltip title={props.item.helpText} classes={{ tooltip: css(Styles.tooltip) }}>
          <div className={css(Styles.labelInfoImgContainer)}>
            <img src={require('../assets/images/info-circle.svg')} className={css(Styles.img)} />
          </div>
        </Tooltip>
      }
    </div>
  )
}

export function TextBox(props) {
  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.label} item={props.item} />
      <TextField
        className={css(Styles.textFeildStyle)}
        placeholder={props.item.placeholder}
        value={props.value}
        onChange={(e) => props.handleTextBox(props.item.key, e)}
        InputProps={{
          disableUnderline: true,
          startAdornment: <img
            src={props.item.inputImage}
            className={css(Styles.iconImg)}
            height='18' width='18'
            alt={props.item.imageAlt} />,
          classes: {
            root: css(Styles.textInputStyles)
          }
        }}
      />
    </div>
  )
}

export function SliderComponent(props) {
  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <div className={css(Styles.sliderOuterContainer)}>
        <p className={css(Styles.label)}>{props.item.label}</p>
        <p className={css(Styles.label, Styles.fontWeight400)}>{props.value && props.value}</p>
      </div>
      <Slider
        disabled = {props.disabled || false}
        aria-label='radius'
        value={props.value}
        classes={{
          root: css(Styles.sliderRoot),
          thumb: css(props.disabled ? Styles.thumbDisabled : Styles.thumb),
          track: css(Styles.track),
          rail: css(Styles.rail),
          mark: css(Styles.sliderMark),
          markLabel: css(Styles.sliderMarkLabel),
        }}
        marks={props.item.marks}
        onChange={(e, value) => props.handleSlider(e, value)}
        onChangeCommitted={props.handleSliderCommited}
      />
    </div>
  )
}

export function DateField(props) {
  const myTheme = createMuiTheme({
    overrides: {
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: AppConfig.TINT_COLOUR
          }
        }
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: AppConfig.TINT_COLOUR
        },
      },
      MuiPickersDay: {
        isSelected: {
          backgroundColor: AppConfig.TINT_COLOUR,
          '&:focus': {
            backgroundColor: AppConfig.TINT_COLOUR
          }
        },
        current: {
          backgroundColor: AppConfig.TINT_COLOUR,
        }
      },
      MuiPickersModal: {
        dialogAction: {
          backgroundColor: AppConfig.TINT_COLOUR
        },
      },
      MuiButton: {
        textPrimary: {
          color: AppConfig.TINT_COLOUR,
          fontWeight: 400,
        }
      }
    },
  });

  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.label} item={props.item} />
      <MuiThemeProvider theme={myTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment} >
          <DatePicker
            variant={'standard'}
            InputAdornmentProps={{ position: 'start' }}
            keyboardIcon={<img src={props.item.inputImage}
              className={css(Styles.iconImg)}
              height='18' width='18' alt={props.item.imageAlt} />}
            format='DD-MMM-YYYY'
            placeholder='DD/MM/YY'
            value={props.value || null}
            onChange={(e) => props.handleDateChange(props.item.key, e)}
            animateYearScrolling={false}
            fullWidth
            className={css(Styles.textFeildStyle)}
            InputProps={{
              disableUnderline: true,
              startAdornment: <img src={props.item.inputImage}
                className={css(Styles.iconImg)}
                height='18' width='18' alt={props.item.imageAlt} />,
              classes: {
                root: css(Styles.textInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
          />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </div>
  )
}

export function SelectBox(props) {
  const useStyle = makeStyles(theme =>
    createStyles({
      option: {
        '&[aria-selected="true"]': {
          backgroundColor: '#037BFE',
        },
      }
    }))

  const highlightedOption = useStyle()
  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.label} item={props.item} />
      {props.item.tip &&
        <span className={css(Styles.tip)}>{props.item.tip}</span>
      }
      <Autocomplete
        fullWidth
        value={props.value}
        key={props.item.key}
        name={props.item.key}
        options={props.optionData} // What needs to be shwon in dropdown
        disabled={props.disabled}
        getOptionLabel={(option) => option.value} // What needs to be shown in the select box once a value is selected
        onChange={(e, val) => props.handleSelectBox(e, val, props.item.key)} // This is the field key, not dropdown list key
        getOptionSelected={(option) => option.key === props.value.key ? true : false} // getting the selected value from dropdown. This should be based on key.
        classes={{
          paper: css(Styles.selectBoxPaper),
          popper: css(Styles.listBoxPaper),
          popupIndicator: css(Styles.dropDownIndicator),
          clearIndicator: css(Styles.clearIndicator),
          endAdornment: css(Styles.endAdornmentStyle),
          option: highlightedOption.option
        }}
        popupIcon={<div className={css(Styles.dropdownarrowImageContainer)}>
          <img
            src={require('../assets/images/arrow-down.svg')}
            width='12'
            height='12'
            alt={Helper.getString('dropdownarrowImageAlt')}
            className={css(Styles.img)} />
        </div>}
        renderOption={(option) => ( // What needs to be shown dropdownlist
          <p className={css(Styles.selectInputStyles)}>
            {option.value}
          </p>
        )}
        renderInput={(params) => <TextField {...params}
          placeholder={props.item.placeholder}
          className={css(Styles.textFeildStyle, props.selectStyle)}
          InputProps={{
            ...params.InputProps,
            startAdornment: <img src={props.item.inputImage}
              className={css(Styles.iconImg)}
              height='18' width='18' alt={props.item.imageAlt} />,
            disableUnderline: true,
            classes: {
              root: css(Styles.textInputStyles, Styles.selectInputStyle)
            }
          }} />}
      />
    </div>
  )
}

export function SelectBoxMulti(props) {

  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.label} item={props.item} />
      <Autocomplete
        multiple
        value={props.value}
        options={props.optionData.map((option) => option.value)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip variant='outlined' label={option} {...getTagProps({ index })} />
          ))
        }
        onChange={(e, val) => props.handleSelectBox(e, val, props.item.key)} // This is the field key, not dropdown list key
        renderInput={(params) => (
          <TextField {...params}
            placeholder={props.value && props.value.length === 0 ? props.item.placeholder : ''}
            className={css(Styles.textFeildStyle, props.selectStyle)}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              classes: {
                root: css(Styles.textInputStyles, Styles.selectInputStyle)
              }
            }} />
        )}
      />
    </div>
  )
}

export function CheckBoxComponent(props) {
  return (
    <div className={css(Styles.checkboxOuterContainer)} style={props.item.id === 'selectall' ? { backgroundColor: '#ffffff' } : { backgroundColor: '#f5f5f5' }}>
      <div className={css(Styles.rowContainer)}>
        {!props.venueExplorer &&
        <Checkbox
          key={props.item.id}
          type='checkbox'
          name={props.name}
          id={props.item.id}
          onChange={(e) => props.handleCheckBoxClick(props.item.id, e)}
          checked={props.isChecked}
          value={props.isChecked}
          classes={{
            root: css(Styles.checkBoxRoot),
            checked: css(Styles.checkboxChecked),
            disabled: css(Styles.checkboxDisabled)
          }}
          disabled={props.item && props.item.onlineStatus && props.item.onlineStatus === 'OFFLINE'}
        />
        }
        <div className={css(Styles.checkboxLabelContainer)}>
          <p className={css(Styles.checkboxLabel)}>{props.item.descr2 || props.item.title}</p>
          <p className={css(Styles.checkboxDescr)}>{props.item.address}</p>
          {props.item && props.item.onlineStatus && props.item.onlineStatus === 'OFFLINE' &&
          <span>
            <Tooltip className={css(Styles.offlineTag)} title={'This screen has been offline for several days and cannot be selected at this point for advertisements.'}>
              <Chip label='Offline' />
            </Tooltip>
          </span>
          }
        </div>
      </div>
      {props.item.id !== 'selectall' &&
        <div className={css(Styles.rowContainer)}>
          <div className={css(Styles.locationImgContainer)}>
            {props.item.image ?
              <img
                src={props.item.image}
                className={css(Styles.venueImg)}
                height='110'
                width='110'
                alt={Helper.getString('locationImageAlt')} />
              :
              <img
                src={require('../assets/images/monitor.svg')}
                height='25'
                width='25'
                alt={Helper.getString('locationImageAlt')} />
            }
          </div>
        </div>
      }
    </div>
  )
}

export function RadioButton(props) {
  const useStyle = makeStyles(theme =>
    createStyles({
      customRadioButton: {
        '& svg': {
          width: '14px',
          height: '14px',
        },
        marginRight: '0px'
      }
    })
  )
  const radioButton = useStyle()

  return (
    <div className={css(Styles.radioButtonContainer, props.radioButtonContainer)}>
      <FormControlLabel
        value={props.value}
        control={<Radio
          checked={props.selectedValue === props.value}
          onChange={(e) => props.handleChange(e, props.name)}
          value={props.value}
          name={props.name}
          classes={{ root: css(Styles.radioButtonStyle) }}
        />}
        className={radioButton.customRadioButton}
      />
      <p className={css(Styles.radioButtonLabel)}>{props.label}</p>
    </div>
  )
}

export function PlacesTextBox(props) {
  useEffect(() => {
    setTimeout(initAutocomplete, 500)
  }, [])

  const initAutocomplete = () => {
    const inputNode = document.getElementById('pac-input');
    if (window && window.google) {
      const autoComplete = new window.google.maps.places.Autocomplete(inputNode);
      autoComplete.setFields(['address_component', 'adr_address', 'name', 'formatted_address', 'geometry'])
      autoComplete.addListener('place_changed', () => {
        const place = autoComplete.getPlace();
        props.handlePlaceTextBox(props.item.key, place)
      });
    }
  }
  let clearIcon = {}
  if (props.onClearLocation) {
    clearIcon = {
      endAdornment: <img
        src={require('../assets/images/close.svg')}
        alt={Helper.getString('clearLocation')}
        onClick={()=> { props.onClearLocation() }}
        className={css(Styles.closeIcon)} />
    }
  }

  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.label} item={props.item} />
      <TextField
        id={'pac-input'}
        className={css(Styles.textFeildStyle)}
        placeholder={props.item.placeholder}
        value={props.value}
        onChange={(e) => props.handleTextBox(props.item.key, e)}
        InputProps={{
          disableUnderline: true,
          startAdornment: <img
            src={props.item.inputImage}
            className={css(Styles.iconImg)}
            height='18'
            width='18'
            alt={props.item.imageAlt} />,
          classes: {
            root: css(Styles.textInputStyles)
          },
          ...clearIcon
        }}
      />
    </div>
  )
}

const Styles = StyleSheet.create({
  closeIcon: {
    width: 24,
    height: 24,
    cursor: 'pointer'
  },
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 32,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B1B1B',
    margin: 0,
  },
  textFeildStyle: {
    minHeight: 54,
    borderRadius: 16,
    backgroundColor: '#F6F6F8',
  },
  textInputStyles: {
    border: 'none',
    padding: '0px 14px',
    flex: 1,
    textAlign: 'left',
    fontSize: 16,
    color: '#000000',
    '::placeHolder': {
      color: '#747474',
    }
  },
  iconImg: {
    height: 18,
    width: 18,
    marginRight: 10
  },
  sliderOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 23
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8
  },
  labelInfoImgContainer: {
    display: 'flex',
    width: 12,
    height: 12,
    marginLeft: 6,
    objectFit: 'cover'
  },
  img: {
    width: 'auto',
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
  },
  tooltip: {
    backgroundColor: AppConfig.TINT_COLOUR,
    borderRadius: 8,
    fontSize: 16,
    whiteSpace: 'pre-wrap',
    color: '#ffffff',
  },
  track: {
    height: 6,
    borderRadius: 4,
    backgroundColor: 'unset'
  },
  rail: {
    height: 5,
    borderRadius: 4,
    backgroundColor: '#bfbdbd !important'
  },
  sliderRoot: {
    height: 1,
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: AppConfig.TINT_COLOUR,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  sliderMark: {
    background: 'unset'
  },
  sliderMarkLabel: {
    color: '#747474',
  },
  checkboxOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
    wordBreak: 'break-word',
    borderRadius: 20,
    padding: 10,
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  checkboxLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkboxLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0,
    marginBottom: 6
  },
  checkboxDescr: {
    fontSize: 14,
    fontWeight: 400,
    color: '#747474',
    margin: 0,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  locationImgContainer: {
    height: 110,
    width: 110,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 20,
    border: '1px solid #d3d3d3',
    marginLeft: 6,
    overflow: 'hidden',
    '@media (max-width: 767px)': {
      width: '100%',
      height: 'auto',
      margin: 0,
      marginTop: 10,
      aspectRatio: '1/1'
    }
  },
  radioButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 32
  },
  radioButtonStyle: {
    color: AppConfig.TINT_COLOUR,
    borderColor: '#747474'
  },
  radioButtonLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#747474',
    margin: 0,
  },
  fontWeight400: {
    fontWeight: 400
  },
  checkBoxRoot: {
    color: '#747474'
  },
  checkboxChecked: {
    color: AppConfig.TINT_COLOUR
  },
  checkboxDisabled:{
    color: '#e2e3e4',
  },
  selectBoxPaper: {
    fontSize: 16,
    backgroundColor: '#F6F6F8',
  },
  dropDownIndicator: {
    marginRight: 12
  },
  dropdownarrowImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 20,
  },
  clearIndicator: {
    color: '#1B1B1B',
    fontSize: 12
  },
  selectInputStyles: {
    fontSize: 16,
    color: '#000000',
    margin: 0
  },
  tip: {
    fontSize: 13,
    marginBottom: 14,
    color: '#747474'
  },
  venueImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  thumbDisabled: {
    height: 14,
    width: 14,
    backgroundColor: '#ccc',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  offlineTag:{
    height: 24,
    marginTop: 6
  }
})


// WEBPACK FOOTER //
// ./src/components/FormInputs.js